var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    rx: 8,
    fill: "#6C5CE7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 17.6676C24.2739 16.6577 23.0888 16 21.75 16H18C16.3431 16 15 17.3431 15 19V29C15 30.6569 16.3431 32 18 32H21.0263C21.6712 32 22.3119 32.104 22.9237 32.3079L24.6838 32.8946C24.889 32.963 25.111 32.963 25.3162 32.8946L27.0763 32.3079C27.6881 32.104 28.3288 32 28.9737 32H32C33.6569 32 35 30.6569 35 29V19C35 17.3431 33.6569 16 32 16H28.25C26.9112 16 25.7261 16.6577 25 17.6676ZM24.25 31.0729V20C24.25 18.6193 23.1307 17.5 21.75 17.5H18C17.1716 17.5 16.5 18.1716 16.5 19V29C16.5 29.8284 17.1716 30.5 18 30.5H21.0263C21.8324 30.5 22.6333 30.63 23.398 30.8849L24.1745 31.1437C24.1991 31.1195 24.2243 31.0959 24.25 31.0729ZM25.75 20V31.0729C25.7757 31.0959 25.8009 31.1195 25.8255 31.1437L26.602 30.8849C27.3667 30.63 28.1676 30.5 28.9737 30.5H32C32.8284 30.5 33.5 29.8284 33.5 29V19C33.5 18.1716 32.8284 17.5 32 17.5H28.25C26.8693 17.5 25.75 18.6193 25.75 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/post-icon.a00e38cf7b69457c8455c46de09f04c7.svg";
export { ForwardRef as ReactComponent };